import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59ad3bec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notfound-wrap" }

import Main from '@teams/common/components/error/main.vue'
import notFoundImg from '@/assets/groupStatus/notFound.svg'

export default /*#__PURE__*/_defineComponent({
  __name: 'invite',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Main, {
      img: _unref(notFoundImg),
      title: "暂无可访问内容"
    }, null, 8, ["img"])
  ]))
}
}

})